const POST_LOGIN_REDIRECT_KEY = "post-login-redirect";

/**
 * Where LoginForm wants the user to land once AuthLayout's `user` effect
 * fires and performs the actual post-login navigation. AuthLayout is the
 * single place that owns navigating away from an auth page once a user is
 * authenticated (it also handles landing on an auth page while already
 * signed in) - LoginForm used to call router.replace() itself too, which
 * raced AuthLayout's own effect since both react to the same "user became
 * authenticated" transition, and could send the user to whichever target won
 * the race.
 */
export function setPostLoginRedirect(path: string): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
}

export function consumePostLoginRedirect(): string | null {
  if (typeof window === "undefined") return null;
  const path = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return path;
}
